import { Component, Inject } from '@angular/core';
import { AnalyticsService } from '../../services/analytics.service';
import { PresaleDataService } from '../../services/connection-services/data.service';
import { WINDOW } from '../../services/window';
import { CHAINS } from '../../shared/constants/app-enums';

@Component({
  selector: 'app-how-to-buy',
  templateUrl: './how-to-buy.component.html',
  styleUrl: './how-to-buy.component.scss',
})
export class HowToBuyComponent {
  currencies = [
    {
      img: 'ETH',
      txt: 'ETH'
    },
    {
      img: 'BNB',
      txt: 'BNB'
    },
    {
      img: 'usdc',
      txt: 'USDC'
    },
    {
      img: 'usdt',
      txt: 'USDT'
    },
    {
      img: 'sol',
      txt: 'SOL'
    },
    {
      img: 'card_payments',
      txt: 'Card'
    },
  ];

  steps = [
    {
      img: 'wallet-icon',
      title: 'how-to-buy.title1',
      desc: 'how-to-buy.desc1'
    },
    {
      img: 'buy-with-card',
      title: 'how-to-buy.title2',
      desc: 'how-to-buy.desc2'
    },
    {
      img: 'clock',
      title: 'how-to-buy.title3',
      desc: 'how-to-buy.desc3'
    }
  ]
  walletAddress = '';

  constructor(private dataService: PresaleDataService,
    private analyticsService: AnalyticsService,
    @Inject(WINDOW) private window: Window,
  ) {
    this.dataService.$walletAddress.subscribe((item) => {
      this.walletAddress = this.dataService?.activeChain === CHAINS.SOL ? this.dataService.walletAddressSOL : this.dataService.walletAddress
    })
  }

  showWidget(section: string): void {
    this.analyticsService.vwoData('walletConnectionPlacement', { placement: 'HowToBuy' });
    if (this.window) {
      window.location.hash = 'home';
    }
    window.scroll({ top: 0 });
    if (!this.walletAddress) {
      setTimeout(() => {
        this.dataService.connectWallet();
      }, 1000);
    }
  }
}
